import * as React from 'react';
import { useRefreshStickyPosition } from './hooks';

export function StickyPositionRefreshProvider(props: React.PropsWithChildren<{}>) {
  const { children } = props;
  useRefreshStickyPosition();
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
